import { render, staticRenderFns } from "./payoutOrder.vue?vue&type=template&id=5a5044df"
import script from "./payoutOrder.vue?vue&type=script&lang=ts"
export * from "./payoutOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports